import React from 'react';

export const ErrorCard = ({ title, description, showContactInfo }) => {
    return (
        <div className="error-card">
            <h1>{title}</h1>
            
            <div className="content-container">
                <p className="txt-lg">{description}</p>
                {showContactInfo && (
                    <p className="txt-md">
                        Please try again later or contact <a href="https://www.vu.edu.au/contact-us" target="_blank">VUHQ</a> for further information.
                    </p>
                )}
            </div>
        </div>
    )
}